<template>
    <page>
        <div class="nav-tabs-container pt-1">
            <div class="nav-tabs-scroll-helper">
                <ul class="nav nav-tabs">

                    <li class="nav-item" v-for="(tab, index) in tabs" :key="tab.value">
                        <a
                            class="nav-link"
                            :class="{'active': mode == tab.value}"
                            href
                            :id="`tabLinkFilesToCreate${index + 1}`"
                            role="tab"
                            :aria-controls="`tabContentFilesToCreate${index + 1}`"
                            :aria-selected="mode == tab.value"
                            @click.prevent="setMode(tab.value)"
                        >
                            {{ tab.text }} ({{ runsForTab(tab.value).length }})
                        </a>
                    </li>

                </ul>
            </div>
        </div>

        <div class="flex-body flex-container tab-content">
            <div
                v-for="(tab, index) in tabs"
                :key="tab.value"
                class="flex-body flex-container tab-pane"
                :class="{'show active': mode == tab.value}"
                :id="`tabContentFilesToCreate${index + 1}`"
                role="tabpanel"
                :aria-labelledby="`tabLinkFilesToCreate${index + 1}`"
            >
                <files-to-create-table
                    v-if="dataLoaded && mode == tab.value"
                    :paygroup-runs="runsForTab(tab.value)"
                    :variant="tab.value"
                    @updated="getRuns"
                />
            </div>
        </div>
    </page>
</template>

<script>
import FilesToCreateTable from './components/FilesToCreateTable'
import Page from '@/components/Page'

// Each file-type tab is named for the file ops asks for and keyed by the PaygroupRun
// flag that file sets.
const TABS = [
    {text: 'All', value: 'all'},
    {text: 'ACH', value: 'verifund'},
    {text: 'Taxes', value: 'asure'},
    {text: 'OBC', value: 'kotapay'},
]

export default {
    components: {FilesToCreateTable, Page, },
    data() {
        return {
            paygroupRuns: [],
            dataLoaded: false,
            mode: 'all',
            tabs: TABS,
        }
    },
    mounted() {
        this.$store.dispatch('SET_PAGE_TITLE', 'Daily Payroll / Files to Create')
        this.getRuns()
    },
    methods: {
        runsForTab(mode) {
            // A run belongs on a file type's tab until that file has been created for
            // it; the All tab holds every run still missing at least one file.
            if (mode == 'all') {
                return this.paygroupRuns.filter(run => {
                    return !run.verifund_created || !run.asure_created || !run.kotapay_created
                })
            }
            return this.paygroupRuns.filter(run => !run[`${mode}_created`])
        },
        setMode(mode) {
            this.mode = mode
            this.$bus.$emit('resize')
        },
        getRuns() {
            this.$store.dispatch('START_LOADING')
            this.$api.get('/admin/daily-payroll/files-to-create').then(resp => {
                this.paygroupRuns = resp.paygroup_runs
                this.dataLoaded = true
                this.$store.dispatch('STOP_LOADING')
            }).catch(errors => {
                this.$store.dispatch('STOP_LOADING')
                this.$bus.showError(errors.__all__)
            })
        },
    },
}
</script>
